export const SETTINGS = {
  ga: {
    live: 'UA-141153181-5',
    dev: 'UA-141153181-4',
    local: 'UA-141153181-6'
  }
}